import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="forms--number-input"
export default class extends Controller {
  static targets = ["number"];

  connect() {
    this.numberTarget.value = this.clamp(
      this.normalizedValue(this.numberTarget.value),
    );
  }

  increment() {
    const value = this.normalizedValue(this.numberTarget.value);
    this.numberTarget.value = this.clamp(value + this.stepValue());
  }

  decrement() {
    const value = this.normalizedValue(this.numberTarget.value);
    this.numberTarget.value = this.clamp(value - this.stepValue());
  }

  normalizedValue(raw) {
    const value = parseInt(raw, 10);
    return Number.isNaN(value) ? this.minValue() : value;
  }

  minValue() {
    const raw = this.numberTarget.min;
    if (raw === "" || raw == null) return 1;

    const value = parseInt(raw, 10);
    return Number.isNaN(value) ? 1 : value;
  }

  stepValue() {
    const raw = this.numberTarget.step;
    if (raw === "" || raw == null) return 1;

    const value = parseInt(raw, 10);
    return Number.isNaN(value) || value < 1 ? 1 : value;
  }

  maxValue() {
    const raw = this.numberTarget.max;
    if (raw === "" || raw == null) return null;

    const value = parseInt(raw, 10);
    return Number.isNaN(value) ? null : value;
  }

  clamp(value) {
    const min = this.minValue();
    const step = this.stepValue();
    let clamped = Math.max(min, Math.trunc(value));

    if (step > 1) {
      const remainder = (clamped - min) % step;
      if (remainder !== 0) {
        clamped = clamped - remainder;
        if (clamped < min) clamped = min;
      }
    }

    const max = this.maxValue();
    if (max != null) {
      clamped = Math.min(max, clamped);
    }

    return clamped;
  }
}
